// TODO: Patron Redux en revisión de cargos en proceso
import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import {
  Button,
  Col,
  Container,
  FormGroup,
  FormText,
  Label,
  Row,
  TabPane
} from "reactstrap";
import { PARTNER_MEMB_PENDIENTE_PAGO_STATUS } from "../../../../utils/constants";
import { handleOBRequestError } from "../../../../utils/helpers";
import {
  errorNotification,
  infoNotification
} from "../../../../utils/notifications";
import { createPaymentLineForPreactivationPayment } from "../../../actions/partners";
import {
  deletePaymentLineRequest,
  getPaymentLineRequest
} from "../../../actions/paymentLines";
import MexicanCurrency from "../../common/currency";
import IFrameContainer from "../../common/iframeContainer/iFrameContainer";
import { Partner } from "../interfaces";
import s from "./styles.scss";
import { errorOBNotification } from "../../../../OnBoardingUI/components/OBNotification/OBNotification.utils";

const ESTATUS_MEMBRESIA_PENDIENTE_PAGO = [PARTNER_MEMB_PENDIENTE_PAGO_STATUS];

interface Props {
  partner: Partner;
  movementsList: object[];
  idMembresia: string;
  idMembresiaSocio: string;
  loadingData: boolean;
  loadingDataMessage: String;
  getMovements: () => any;
  invalidateStateValue: (fieldName: string, value: any) => void;
  refreshPartner: () => void;
  plataforma: string;
}

class TabMovements extends React.Component<Props> {
  state = {
    saving: false,
    waiting: false,
    iFrameModalIsOpen: false,
    iFrameModalSrc: null,
    lineaPagoData: null
  };

  isMembershipPendientePago = () => {
    return (
      !!this.props.partner &&
      ESTATUS_MEMBRESIA_PENDIENTE_PAGO.includes(
        this.props.partner.estatusMembresia
      )
    );
  };

  invalidateMovementsData = () => {
    this.props.invalidateStateValue("movementsList", []);
    this.props.getMovements();
  };

  render() {
    const { movementsList } = this.props;
    const pendingCharges = (movementsList || []).filter(
      x => x.estatus == "PENDIENTE"
    );

    return (
      <TabPane className="my-2" tabId="3">
        {!this.state.iFrameModalIsOpen && (
          <Container className="p-0 m-0">
            <div style={{ marginLeft: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  marginBottom: "4px"
                }}
              >
                Nombre del cliente:
              </div>
              <div
                style={{
                  fontSize: "12px",
                  marginBottom: "10px"
                }}
              >
                {this.props.partner.nombrePersona}
              </div>
            </div>
            <hr />
            {!this.isMembershipPendientePago() && (
              <div
                className={`${s.infoCard} ${s.gray}`}
                style={{ margin: "0 24px 10px 24px" }}
              >
                Antes de adquirir tu membresía, tienes que firmar tus
                documentos.
              </div>
            )}
            {this.isMembershipPendientePago() &&
              (pendingCharges || []).length > 0 && (
                <div className="m-4">
                  <FormGroup>
                    <Label style={{ fontWeight: "700", fontSize: "14px" }}>
                      Cargos pendientes:
                    </Label>
                    <FormText color="muted">
                      {(pendingCharges || []).map((pc, index) => {
                        return (
                          <Row key={index} className="m-2">
                            <Col xs="9">
                              <span style={{ fontSize: "12px" }}>
                                {pc.descripcion}
                              </span>
                            </Col>
                            <Col xs="3">
                              <MexicanCurrency quantity={pc.importe || 0} />
                            </Col>
                          </Row>
                        );
                      })}
                    </FormText>
                  </FormGroup>
                </div>
              )}

            {this.isMembershipPendientePago() && (
              <div className="m-4">
                <Button
                  className="bg-secondary mr-4"
                  size="sm"
                  disabled={!!this.state.waiting}
                  block
                  onClick={e => {
                    e.preventDefault();

                    this.setState({ waiting: true });
                    infoNotification("Generando ");

                    const { idMembresiaSocio } = this.props;
                    createPaymentLineForPreactivationPayment(
                      idMembresiaSocio,
                      this.props.plataforma
                    )
                      .then(({ data }) => {
                        console.info(data);
                        this.setState({ waiting: false });

                        this.setState({
                          lineaPagoData: data,
                          iFrameModalSrc: data.url,
                          iFrameModalIsOpen: true
                        });
                      })
                      .catch(error => {
                        this.setState({ waiting: false });
                        errorOBNotification(
                          "¡Ooops! No se pudo obtener tu línea de pago, intenta de nuevo por favor."
                        );
                        handleOBRequestError(error);
                      });
                  }}
                >
                  Pagar en línea
                </Button>
              </div>
            )}
          </Container>
        )}

        {this.isMembershipPendientePago() && this.state.iFrameModalIsOpen && (
          <IFrameContainer
            title={
              "Pago de membresía y cargos de mantenimiento / anualidad en línea"
            }
            okTitle={"Procesar pago"}
            waiting={this.state.waiting}
            ok={() => {
              const { idMembresiaSocio } = this.props;
              const { lineaPagoData } = this.state;
              this.setState({ waiting: true });

              setTimeout(() => {
                getPaymentLineRequest(lineaPagoData.id)
                  .then(({ data: lp }) => {
                    if (
                      ["COBRADA_MIT", "FACTURADA"].includes(lp.estatus || "")
                    ) {
                      this.setState({
                        iFrameModalSrc: null,
                        iFrameModalIsOpen: false,
                        lineaPagoData: null,
                        waiting: false
                      });

                      this.props.invalidateStateValue("paymentMethods", []);
                      this.props.getMovements();
                      this.props.refreshPartner();
                    } else {
                      errorOBNotification(
                        "¡Ooops! Aún no detectamos tu pago, intenta de nuevo por favor."
                      );
                      this.setState({ waiting: false });
                    }
                  })
                  .catch(error => {
                    this.setState({ waiting: false });
                    errorOBNotification(
                      "¡Ooops! Aún no detectamos tu pago, intenta de nuevo por favor."
                    );
                  });
              }, 8000);

              /* markPaymentLineAsCompleted(idMembresiaSocio, lineaPagoData)
                .then(() => {
                  this.setState({
                    iFrameModalSrc: null,
                    iFrameModalIsOpen: false,
                    lineaPagoData: null,
                    waiting: false
                  });

                  this.props.invalidateStateValue("movementsList", []);
                  this.props.getMovements();

                  if (this.props.refreshPartner) {
                    this.props.refreshPartner();
                  }
                })
                .catch(error => {
                  this.setState({ waiting: false });
                  handleOBRequestError(error);
                }); */
            }}
            cancel={() => {
              const { lineaPagoData } = this.state;
              this.setState({ waiting: true });

              deletePaymentLineRequest(lineaPagoData.id)
                .then(() => {
                  this.setState({
                    iFrameModalSrc: null,
                    iFrameModalIsOpen: false,
                    lineaPagoData: null,
                    waiting: false
                  });
                })
                .catch(error => {
                  this.setState({ waiting: false });
                  handleOBRequestError(error);
                });
            }}
            src={this.state.iFrameModalSrc}
          />
        )}
      </TabPane>
    );
  }
}

export default withStyles(s)(TabMovements);
